import { render, staticRenderFns } from "./Preloader.vue?vue&type=template&id=40506720&"
import script from "./Preloader.vue?vue&type=script&lang=js&"
export * from "./Preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40506720')) {
      api.createRecord('40506720', component.options)
    } else {
      api.reload('40506720', component.options)
    }
    module.hot.accept("./Preloader.vue?vue&type=template&id=40506720&", function () {
      api.rerender('40506720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/integration/msteams/components/Preloader.vue"
export default component.exports